import * as React from "react";
import CardsManager from "../CardsManager/CardsManager";
import Calendar from "./Calendar";
import { useMediaQuery } from "react-responsive";
import MobileCalendar from "../MobileCalendar/MobileCalendar";
import { useParams } from "react-router-dom";
import { parse, startOfYear } from "date-fns";

const CalendarWrapper: React.FC = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 1025 });
	const params = useParams<{ year?: string; month?: string; id?: string }>();

	const forceToOld = localStorage.getItem("calendarForceOld") === "true";

	const openDate = React.useMemo(() => {
		if (params?.year) {
			return parse(params.year, "yyyy", new Date());
		}

		return null;
	}, [params]);

	const [currentDate, setCurrentDate] = React.useState<Date>(
		openDate ? openDate : startOfYear(new Date())
	);

	React.useEffect(() => {
		if (openDate) {
			setCurrentDate(openDate);
		}
	}, [openDate]);

	return (
		<CardsManager
			type="calendar"
			welcomeType="calendar"
			currentDate={currentDate}
			enableWelcomeBook={true}
		>
			{(callbacks) => (
				<>
					{(!isMobile || forceToOld) && (
						<Calendar
							callbacks={callbacks}
							setDate={setCurrentDate}
							openDate={startOfYear(currentDate)}
						/>
					)}

					{isMobile && !forceToOld && (
						<MobileCalendar
							callbacks={callbacks}
							year={params.year}
							month={params.month}
							id={params.id}
							openDate={startOfYear(currentDate)}
							setDate={setCurrentDate}
						/>
					)}
				</>
			)}
		</CardsManager>
	);
};

export default CalendarWrapper;
